import { LazyMotion } from 'framer-motion';
import React from 'react';

// framer-motion's DOM animation features (animations, variants, gestures,
// in-view) load in a separate chunk after hydration. Components use `m.*`
// instead of `motion.*`, so the full feature bundle never ships, and `strict`
// throws if a `motion.*` component slips back in. Wired in gatsby-browser.js
// and gatsby-ssr.js.
const loadFeatures = () => import('./motionFeatures').then((mod) => mod.default);

const MotionProvider = ({ children }) => (
  <LazyMotion features={loadFeatures} strict>
    {children}
  </LazyMotion>
);

export default MotionProvider;
